import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import DeletedUsersViewModel from '@/ViewModels/Controls/DeletedUsersViewModel';
import DeletedUsers from '@/Controls/DeletedUsers';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class DeletedUsersFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private DeletedUsersViewModel = ComponentManager.getViewModel<typeof DeletedUsersViewModel>('DeletedUsersViewModel');
    private DeletedUsers = ComponentManager.getControl<typeof DeletedUsers>('DeletedUsers');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * @override
     */
    public viewModel: DeletedUsersViewModel;

    public constructor(params: any) {
        super(params);

        this.labelPosition = 'None';
        this.colspan = 'Fill';
    }

    /**
     * @override
     */
    control: DeletedUsers;

    /**
     * @override
     */
    public getControl() {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.DeletedUsersViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            detailViewContext: this.context
        });

        this.control = new this.DeletedUsers(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('DeletedUsers', DeletedUsersFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('RADPresentation.DefaultViewExtensions.UIComponents.DeletedUsersDialog', DeletedUsersFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');